import { render } from "./MemberView.vue?vue&type=template&id=54659ed0&scoped=true"
import script from "./MemberView.vue?vue&type=script&lang=js"
export * from "./MemberView.vue?vue&type=script&lang=js"

import "./MemberView.vue?vue&type=style&index=0&id=54659ed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54659ed0"]])

export default __exports__